import script from "./MapGoogle.vue?vue&type=script&setup=true&lang=js"
export * from "./MapGoogle.vue?vue&type=script&setup=true&lang=js"

import "./MapGoogle.vue?vue&type=style&index=0&id=22b08d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b08d6e"]])

export default __exports__